import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
// import { ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import {FmlxToggleButton, FmlxButton} from 'fmlx-common-ui';
import './ToggleRadioButton.scss';

function ToggleRadioButton({selectedId, options, onChange, isCornerRounded, selectedValue, size}) {
  const [selectedIdState, setSelectedIdState] = useState(selectedId);

  useEffect(() => {
    const id = typeof selectedId === 'number' ? selectedId : options.findIndex((el) => el?.value === selectedValue);

    setSelectedIdState(id);
  }, [selectedValue, selectedId, options]);

  const onChangeHandler = (indexValue) => {
    const newSelectedId = typeof indexValue === 'number' ? indexValue : selectedIdState;

    if (newSelectedId !== selectedIdState) setSelectedIdState(indexValue);
    onChange(options[newSelectedId]?.value, newSelectedId);
  };

  return (
    <div className={`${!isCornerRounded && 'square-button'} fast-toggle-button`}>
      <FmlxToggleButton items={options} size={size} onChange={(idx) => onChangeHandler(idx)} value={selectedIdState} />
    </div>
  );
}

ToggleRadioButton.propTypes = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  isCornerRounded: PropTypes.bool,
  selectedId: PropTypes.number,
  selectedValue: PropTypes.any,
  size: PropTypes.string,
};

ToggleRadioButton.defaultProps = {
  isCornerRounded: true,
  selectedId: null,
  selectedValue: null,
  size: FmlxButton.Size.MEDIUM,
};

export default ToggleRadioButton;
